import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { HealthcareProfessional } from '../HealthcareProfessional.ts';
import { useIdFromRoute } from '../../../hooks/useIdFromRoute.tsx';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function useGetHealthcareProfessionalById() {
    const { currentUser } = useSessionProvider();
    const id = useIdFromRoute() || currentUser?.healthcareProfessionalID;

    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.healthcareProfessional, id],
        queryFn: async () => {
            if (id) {
                const result = await HealthcareProfessionalsApi.getHealthcareProfessionalById(id);
                return result ? new HealthcareProfessional(result) : undefined;
            }
        },
        enabled: !!id,
    });
}
